import { CommonModule } from '@angular/common';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedPipesModule } from '@shared/shared-pipes.module';

// external libs
import moment from 'moment';
import { DpDatePickerModule } from 'ng2-date-picker';
// import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { DatePickerComponent } from 'ng2-date-picker';

declare var ga: any;

@Component({
  selector: 'app-datepicker',
  standalone: true,
  imports: [CommonModule, FormsModule, DpDatePickerModule, SharedPipesModule],
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit, OnChanges {
  @ViewChild('datePicker') datePicker!: DatePickerComponent; // Use DatePickerComponent
  @ViewChild('datePickerTimeSlot') datePickerTimeSlot!: DatePickerComponent; // Use DatePickerComponent
  isDatePickerOpen = false; // Tracks the state of the date picker
  @Input()
  selectedDate;

  @Input()
  minDate;

  @Input()
  maxDate;

  @Input()
  disableDates;

  @Input()
  forTimeslot;

  @Input()
  forAmendFlight;

  @Input()
  labelText;

  @Output()
  dateChange: EventEmitter<any> = new EventEmitter();

  public dateInput;
  public defaultMonth = '';
  public dateError: String = 'Please enter a valid date';
  // public myOptions: INgxMyDpOptions;
  public myOptions;

  constructor() { }

  ngOnInit() {

    this.setCalendarOptions();
  }

  // Custom weekday formatter function
  weekDayFormatter = (day: number): string => {
    const weekdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
    return weekdays[day]; // Return abbreviated weekday name (e.g., Sun, Mon)
  };
  currentDate = new Date();

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    hideInputContainer: true,
    weekDayFormat: 'dd',
    opens: 'right',
    weekDayFormatter: this.weekDayFormatter,
    showNearMonthDays: false,
    enableMonthSelector: false,
    showGoToCurrent: false,
    minDate: this.currentDate, // Disable dates before today
    isDayDisabledCallback: (date: moment.Moment): boolean => this.disablePreviousDates(date),
    dayBtnCssClassCallback: (date: moment.Moment): string => this.getClassForDate(date),
  };



  datePickerConfigTimeSlot = {
    format: 'DD-MM-YYYY',
    hideInputContainer: true,
    weekDayFormat: 'dd',
    opens: 'left',
    weekDayFormatter: this.weekDayFormatter,
    showNearMonthDays: false,
    enableMonthSelector: false,
    showGoToCurrent: false,
    min:null,
    max: null,
    // isDayDisabledCallback: (date: moment.Moment): boolean => this.disablePreviousDates(date),
    // dayBtnCssClassCallback: (date: moment.Moment): string => this.getClassForDate(date),
  };

  getClassForDate(date: moment.Moment): string {
    const today = moment(); // Current date

    if (date.isBefore(today, 'day')) {
      return 'disabled-date'; // Add a class for past dates
    } else if (date.isSame(today, 'day')) {
      return 'current-date'; // Add a class for today's date
    }
    return ''; // No class for future dates
  }

  disablePreviousDates(date: moment.Moment): boolean {
    console.log(this.disableDates);
    const today = moment(); // Current date
    // Disable dates before today but allow today
    return date.isBefore(today, 'day');
  }

  toggleDatePicker(): void {
    if (this.datePicker) {
      if (this.isDatePickerOpen) {
        this.datePicker.api.close(); // Close if already open
        this.isDatePickerOpen = false;
      } else {
        this.datePicker.api.open(); // Open if not open
        this.isDatePickerOpen = true;
      }
    } else {
      console.error('Date Picker instance is not available');
    }
  }

  toggleDatePickerTimeslot(): void {
    if (this.datePickerTimeSlot) {
      if (this.isDatePickerOpen) {
        this.datePickerTimeSlot.api.close(); // Close if already open
        this.isDatePickerOpen = false;
      } else {
        this.datePickerTimeSlot.api.open(); // Open if not open
        this.isDatePickerOpen = true;
      }
    } else {
      console.error('Date Picker instance is not available');
    }
  }

  onDateChange(newValue: any): void {
    console.log('Date value changed:', newValue);
  }

  setCalendarOptions () {

    const minDateMoment = moment(this.minDate).subtract(1, 'days');
    const maxDateMoment = moment(this.maxDate).add(1, 'days');
    const selectedDateMoment = moment(this.selectedDate);

    // default month for timeslot page
    const month = moment(this.minDate).month() + 1;
    this.defaultMonth = month < 10 ? '0' + month : '' + month;
    this.defaultMonth += '/' + minDateMoment.year();

    this.myOptions = {
      showSelectorArrow: false,
      showTodayBtn: false,
      markCurrentDay: false,
      monthSelector: false,
      yearSelector: false,
      dayLabels: {su: 'Su', mo: 'Mo', tu: 'Tu', we: 'We', th: 'Th', fr: 'Fr', sa: 'Sa'},
      sunHighlight: false,
      dateFormat: 'dd/mm/yyyy',
      disableUntil: {
        year: minDateMoment.year(),
        month: minDateMoment.month() + 1,
        day: minDateMoment.date()
      },
      disableSince: {
        year: maxDateMoment.year(),
        month: maxDateMoment.month() + 1,
        day: maxDateMoment.date()
      },
      disableDates: this.disableDates
    };

    // update here

    this.datePickerConfigTimeSlot = {...this.datePickerConfigTimeSlot, min: moment(this.minDate, 'YYYY-MM-DD'), max: moment(this.maxDate, 'YYYY-MM-DD')}
    this.dateInput = {
      date: {
        year: selectedDateMoment.year(),
        month: selectedDateMoment.month() + 1,
        day: selectedDateMoment.date()
      }
    };
  }

  dateChanged(val) {
    if (val !== null) {
      this.dateChange.emit(moment(val.$d, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    } else {
      this.dateChange.emit(null);
    }

    ga('send', 'event', 'Vanilla',  'Time Date', val.formatted);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['minDate'] !== 'undefined' && !changes['minDate'].firstChange ||
      typeof changes['maxDate'] !== 'undefined' && !changes['maxDate'].firstChange) {
      this.setCalendarOptions();
    }
  }

}
